import React from 'react';
import ReactDOM from 'react-dom';

import 'typeface-roboto';

import App from './App';

// @ts-expect-error — @types/react-dom@19 dropped render(); React 17 runtime still uses it
ReactDOM.render(<App />, document.getElementById('root'));
